export default __webpack_public_path__ + "bffe84a2b2fe7b283f77b26cec84f5fa.png";